import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

import { Avatar } from 'ui/avatar';
import { Spinner } from 'ui/spinner';
import { BottomToggletip } from 'ui/tooltip';

export const getUserAvatarQuery = gql`
  query getUser($id: String!) {
    user(id: $id) {
      fullName
      avatarUrl
    }
  }
`;

export const UserAvatar = ({
  userId,
  showFullName = false,
  showFullNameTooltip = true,
}: {
  userId: string;
  showFullName?: boolean;
  showFullNameTooltip?: boolean;
}) => {
  const { data, isLoading, error } = useGraphql(getUserAvatarQuery, {
    fetchPolicy: 'cache-and-network',
    variables: {
      id: userId,
    },
  });

  const user = data?.user;
  const userNameArray = user?.fullName?.split(' ');

  if (isLoading) return <Spinner size={24} />;
  if (error) return null;
  if (!userNameArray?.length) return <span>{userId}</span>;

  return (
    <>
      <BottomToggletip
        isEnabled={showFullNameTooltip && !!user?.fullName}
        tooltipContent={user?.fullName}
      >
        <Avatar
          data-test={`avatar-${userId}`}
          firstName={userNameArray[0] || ''}
          lastName={userNameArray[1] || ''}
          imgSrc={user?.avatarUrl}
        />
      </BottomToggletip>
      {showFullName && !!user?.fullName && <span> {user?.fullName} </span>}
    </>
  );
};
